/* 共用 Vehicle Card（BUG跟进 9.17 · P1：BUG44 来源，复用于 BUG59/60/66/103）
   由 snippets/auxito-proto-shell-vehicle-card.liquid 自带 <script defer> 引入。
   页面上可能渲染多张卡片：逐个初始化，重复引入也只绑定一次。

   行为：
   - Change  -> 切到选车态，aria-expanded=true，焦点落到 Year
   - Cancel / Esc（焦点在卡内） -> 回展示态，焦点回 Change
   - submit   -> 三项有占位：Choose your Year, Make & Model.
                 2003 / Chevrolet / Silverado 2500 HD：写 sessionStorage['apsp:ymm'] 并回展示态
                 其他组合：保持选车态，Preview content is available for 2003 Chevrolet Silverado 2500 HD only.
                 卡片带 data-apsp-vcard-targets（'Year|Make|Model|URL;…'）时：命中其中一台 -> 写 ymm，
                 URL 的 view 与当前页不同就跳转过去，相同则只收起；未命中 -> 提示可选车型范围。
   - 显隐优先走 AuxitoProtoShellInteractions.reveal/collapse，不存在时直接切 hidden。 */
(function () {
  'use strict';
  /* 埋点（assets/auxito-proto-shell-tracking.js）：选车成功 / 不支持时上报，脚本没加载时什么都不做 */
  function track(method) {
    var T = window.AuxitoTrack;
    var args = Array.prototype.slice.call(arguments, 1);
    try { if (T && typeof T[method] === 'function') T[method].apply(T, args); } catch (error) { /* 埋点失败不影响页面 */ }
  }

  var STORAGE_KEY = 'apsp:ymm';
  var TARGET = { year: '2003', make: 'Chevrolet', model: 'Silverado 2500 HD' };
  var READY_ATTR = 'data-apsp-vcard-ready';

  function api() {
    var shared = window.AuxitoProtoShellInteractions;
    return shared && typeof shared.reveal === 'function' && typeof shared.collapse === 'function'
      ? shared
      : null;
  }

  function show(el) {
    if (!el) return;
    var shared = api();
    if (shared) {
      shared.reveal(el);
      return;
    }
    el.classList.remove('hidden');
    el.removeAttribute('hidden');
  }

  function hide(el) {
    if (!el) return;
    var shared = api();
    if (shared) {
      shared.collapse(el);
      return;
    }
    el.classList.add('hidden');
    el.setAttribute('hidden', '');
  }

  function isHidden(el) {
    return !el || el.classList.contains('hidden') || el.hasAttribute('hidden');
  }

  function focusSafely(el) {
    if (!el || typeof el.focus !== 'function') return;
    try {
      el.focus();
    } catch (error) {
      /* 忽略：焦点移动失败不影响视图切换 */
    }
  }

  function init(root) {
    var view = root.querySelector('[data-apsp-vcard-view]');
    var picker = root.querySelector('[data-apsp-vcard-picker]');
    var change = root.querySelector('[data-apsp-vcard-change]');
    var cancel = root.querySelector('[data-apsp-vcard-cancel]');
    var msg = root.querySelector('[data-apsp-vcard-msg]');
    var yearSel = root.querySelector('[data-apsp-vcard-year]');
    var makeSel = root.querySelector('[data-apsp-vcard-make]');
    var modelSel = root.querySelector('[data-apsp-vcard-model]');
    if (!view || !picker || !change || !yearSel || !makeSel || !modelSel) return;

    /* 可选的 Lighting Position 一栏（07 Help）：网址 position= 优先；确认时写回网址并刷新 */
    var positionSel = root.querySelector('[data-apsp-vcard-position]');
    if (positionSel) {
      var pageVehicle = window.AuxitoProtoShellVehicle;
      var urlPosition = (pageVehicle && pageVehicle.position) || new URLSearchParams(window.location.search).get('position') || '';
      var hasOption = Array.prototype.some.call(positionSel.options, function (o) { return o.value && o.value === urlPosition; });
      if (hasOption) positionSel.value = urlPosition;
    }
    function withPosition(url) {
      if (!positionSel) return url;
      var u = new URL(url || window.location.href, window.location.href);
      u.searchParams.set('position', positionSel.value);
      return u.pathname + u.search + u.hash;
    }
    function isHere(url) {
      return url === window.location.pathname + window.location.search + window.location.hash;
    }

    /* 可切换车型列表（可选）：'Year|Make|Model|URL;…' */
    var targets = String(root.getAttribute('data-apsp-vcard-targets') || '')
      .split(';')
      .map(function (item) {
        var parts = item.split('|');
        return parts.length >= 3 ? { year: parts[0], make: parts[1], model: parts[2], url: parts[3] || '' } : null;
      })
      .filter(Boolean);
    if (!targets.length) targets = [{ year: TARGET.year, make: TARGET.make, model: TARGET.model, url: '' }];

    /* 公共车型上下文（assets/auxito-proto-shell-context.js，2026-09-24 上线框架）：有就用它的车型清单——
       下拉只列清单里的车（选年份后品牌 / 车型只列有效组合），确认后停在同一类页面换成新车，并写入全站车型。 */
    var ctx = root.hasAttribute('data-apsp-vcard-fixed') ? null : (window.AuxitoProtoShellVehicle || null);
    var storyAttr = root.getAttribute('data-apsp-vcard-stories');
    var storyMode = !!ctx && storyAttr != null; /* 08：下拉只列有已发布故事的车，确认后进该车的故事文章 */
    var bindLaunch = function () {};
    var refillLaunch = function () {};
    if (ctx) {
      /* 07 安装帮助（带 Lighting Position 一栏）：车型库这一年没有灯泡数据的车（如 2004 Silverado 1500 HD、2022 Silverado 1500 LTD / 2500 HD）不列（运营 2026-10-16）。
         「没有灯泡数据」= 既没有挂商品的灯位（fit）也没有安装帮助页的灯位（inst）；只有安装帮助、暂无商品的车照常列出（2.0.12 审查） */
      var listed = positionSel && ctx.formal ? ctx.list.filter(function (v) {
        return (Array.isArray(v.fit) && v.fit.length > 0) || (Array.isArray(v.inst) && v.inst.length > 0);
      }) : ctx.list;
      targets = listed.map(function (v) { return { year: v.year, make: v.make, model: v.model, url: ctx.urlForHere(v), key: v.key }; });
      /* 08 车主故事：只列有已发布故事的车（运营 2026-10-14），确认后进该车的故事文章；data-apsp-vcard-stories = '年份页handle^文章URL;…' */
      if (storyMode) {
        var storyUrl = {};
        storyAttr.split(';').forEach(function (item) {
          var p = item.split('^');
          if (p[0] && p[1] && !storyUrl[p[0]]) storyUrl[p[0]] = p[1];
        });
        targets = ctx.list.filter(function (v) { return v.yh && storyUrl[v.yh]; }).map(function (v) {
          return { year: v.year, make: v.make, model: v.model, url: storyUrl[v.yh], key: v.key };
        });
        /* 没有可选的故事车型时不能换车（不退回全部上线车型） */
        if (!targets.length) {
          change.hidden = true; change.disabled = true;
          var confirmBtn = root.querySelector('.apsp-vcard__confirm');
          if (confirmBtn) confirmBtn.disabled = true;
          if (msg) { msg.textContent = 'No other vehicles with published owner stories yet.'; msg.hidden = false; }
        }
      }
      var nameEl = root.querySelector('.apsp-vcard__name');
      /* 10 页带了非上线车型（context.js 的 outside）：显示这台车，下拉不预选上线车型 */
      if (nameEl) nameEl.textContent = ctx.outside ? ctx.outside.name : ctx.fields.name(ctx.current);
      var fill = function (sel, values, keep, placeholder) {
        sel.innerHTML = '';
        var blank = document.createElement('option'); blank.value = ''; blank.textContent = placeholder; sel.appendChild(blank);
        values.forEach(function (v) { var o = document.createElement('option'); o.value = v; o.textContent = v; sel.appendChild(o); });
        sel.value = values.indexOf(keep) >= 0 ? keep : '';
      };
      var uniq = function (arr) { return arr.filter(function (v, i) { return arr.indexOf(v) === i; }); };
      var fillMakes = function (keep) {
        fill(makeSel, uniq(targets.filter(function (t) { return !yearSel.value || t.year === yearSel.value; }).map(function (t) { return t.make; })).sort(), keep, 'Make');
      };
      var fillModels = function (keep) {
        fill(modelSel, uniq(targets.filter(function (t) { return (!yearSel.value || t.year === yearSel.value) && (!makeSel.value || t.make === makeSel.value); }).map(function (t) { return t.model; })).sort(), keep, 'Model');
      };
      var pre = ctx.outside ? { year: '', make: '', model: '' } : ctx.current;
      var fillLaunch = function () {
        fill(yearSel, uniq(targets.map(function (t) { return t.year; })).sort().reverse(), pre.year, 'Year');
        fillMakes(pre.make);
        fillModels(pre.model);
      };
      var launchBound = false;
      /* 只选上线车型的联动；10 页目录模式读目录失败时也退回这里（PR #55 第五轮审查） */
      bindLaunch = function () {
        if (launchBound) return;
        launchBound = true;
        yearSel.addEventListener('change', function () { fillMakes(makeSel.value); fillModels(modelSel.value); });
        makeSel.addEventListener('change', function () { fillModels(modelSel.value); });
      };
      refillLaunch = fillLaunch;
      fillLaunch();
      if (!catalogMode()) bindLaunch();
    }

    /* 10 Off-Road Builder 对所有车型开放（运营 2026-10-13）：选车卡按全站车型目录（AuxitoVehicleUtils，与页头选车器同一份）选车，
       预选网址带进来的车（context.js outside）或当前上线车型；确认上线车型照旧去它的 10，其他车型带 year / make / model 留在 10 */
    function catalogMode() {
      var u = window.AuxitoVehicleUtils;
      return !!(ctx && (ctx.offroad || ctx.builder) && u && typeof u.getVehicleData === 'function' && typeof u.getYearVehicleData === 'function');
    }
    var catalog = catalogMode();
    var catIndex = null;
    var modelSeq = 0;
    var flat = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); };
    function setOptions(sel, values, keep, placeholder) {
      sel.innerHTML = '';
      var blank = document.createElement('option'); blank.value = ''; blank.textContent = placeholder; sel.appendChild(blank);
      values.forEach(function (v) {
        var o = document.createElement('option'); o.value = v; o.textContent = String(v).replace(/\bHd\b/g, 'HD'); sel.appendChild(o);
      });
      var hit = values.filter(function (v) { return flat(v) === flat(keep); })[0];
      sel.value = hit || '';
    }
    function catYears() {
      return (catIndex.years || []).map(String).filter(function (y) { return /^\d{4}$/.test(y); }).sort(function (a, b) { return b - a; });
    }
    function catMakes(year) {
      var u = window.AuxitoVehicleUtils;
      var seen = {};
      var out = [];
      (year ? [year] : catYears()).forEach(function (y) {
        (u.getCaseInsensitivePropertyValue(catIndex.makesByYear, y) || []).forEach(function (m) {
          if (!seen[flat(m)]) { seen[flat(m)] = 1; out.push(m); }
        });
      });
      return out.sort(function (a, b) { return a.localeCompare(b); });
    }
    function catModels(keep) {
      var u = window.AuxitoVehicleUtils;
      var seq = ++modelSeq;
      if (!yearSel.value || !makeSel.value) { setOptions(modelSel, [], '', 'Model'); return Promise.resolve(); }
      setOptions(modelSel, [], '', 'Model');
      modelSel.disabled = true;
      return u.getYearVehicleData(yearSel.value).then(function (data) {
        if (seq !== modelSeq) return;
        setOptions(modelSel, u.getAvailableModels(data, makeSel.value), keep, 'Model');
      }).catch(function () {
        if (seq === modelSeq) { track('result', 'load_failed', { apsp_module: 'hero' }); setOptions(modelSel, [], '', 'Model'); }
      }).then(function () {
        if (seq === modelSeq) modelSel.disabled = false;
      });
    }
    if (catalog) {
      var pre = ctx.outside || { year: ctx.current.year, make: ctx.current.make, model: ctx.current.lib_model || ctx.current.model };
      window.AuxitoVehicleUtils.getVehicleData().then(function (index) {
        catIndex = index;
        setOptions(yearSel, catYears(), pre.year, 'Year');
        setOptions(makeSel, catMakes(yearSel.value), pre.make, 'Make');
        return catModels(pre.model);
      }).catch(function () {
        track('result', 'load_failed', { apsp_module: 'hero' });
        catalog = false;
        modelSel.disabled = false;
        refillLaunch();
        bindLaunch();
      });
      yearSel.addEventListener('change', function () {
        if (!catIndex) return;
        setOptions(makeSel, catMakes(yearSel.value), makeSel.value, 'Make');
        catModels(modelSel.value);
      });
      makeSel.addEventListener('change', function () { if (catIndex) catModels(''); });
    }

    function viewOf(url) {
      var query = String(url || '').split('#')[0].split('?')[1] || '';
      return new URLSearchParams(query).get('view') || '';
    }

    function setMessage(text) {
      if (!msg) return;
      msg.textContent = text || '';
      if (text) show(msg);
      else hide(msg);
    }

    function openPicker() {
      hide(view);
      show(picker);
      change.setAttribute('aria-expanded', 'true');
      focusSafely(yearSel);
    }

    /* 与 06 一致（2026-09-25）：选车卡一直显示下拉，不再收起回展示态；同一台车确认只清掉提示 */
    function closePicker() {
      setMessage('');
    }

    change.addEventListener('click', openPicker);
    if (cancel) cancel.addEventListener('click', closePicker);

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      if (isHidden(picker)) return;
      var active = document.activeElement;
      if (!active || !root.contains(active)) return;
      event.preventDefault();
      closePicker();
    });

    picker.addEventListener('submit', function (event) {
      event.preventDefault();
      var year = yearSel.value;
      var make = makeSel.value;
      var model = modelSel.value;

      if (!year || !make || !model || (positionSel && !positionSel.value)) {
        setMessage(positionSel ? 'Choose your Year, Make, Model & Lighting Position.' : 'Choose your Year, Make & Model.');
        return;
      }

      if (catalog && catIndex) {
        if (modelSel.disabled) return; /* 车型列表加载中：不提交「新年份 + 旧车型」 */
        var hitLaunch = ctx.match(year, make, model);
        track('vehicleSelected', 'vehicle_card', year, make, model, hitLaunch ? 'yes' : 'no');
        if (hitLaunch) {
          ctx.saveVehicle(hitLaunch);
          var next = ctx.urlForHere(hitLaunch);
          if (ctx.outside || !isHere(next)) { window.location.href = next; return; }
          closePicker();
          return;
        }
        var store = window.Auxito && window.Auxito.Vehicle && window.Auxito.Vehicle.Storage;
        try { if (store && typeof store.addVehicle === 'function') store.addVehicle({ year: String(year), make: make, model: model }); } catch (error) { /* 存不了不影响跳转 */ }
        /* 09：非上线车型去固定页 lighting-builder 显示暂无 Builder（年份页 Builder 视图按页面车型显示，带别的车参数也不会换） */
        var u = new URL(ctx.builder && ctx.builderHome ? ctx.builderHome : window.location.href, window.location.href);
        u.searchParams.delete('vehicle');
        u.searchParams.set('year', year); u.searchParams.set('make', make); u.searchParams.set('model', model);
        window.location.href = u.pathname + u.search;
        return;
      }

      var match = targets.filter(function (t) {
        return t.year === year && t.make === make && t.model === model;
      })[0];
      if (match) track('vehicleSelected', 'vehicle_card', year, make, model, 'yes');
      else track('result', 'unsupported_vehicle', { apsp_module: 'hero' });
      if (match && ctx) {
        var picked = ctx.list.filter(function (v) { return v.key === match.key; })[0];
        if (picked) ctx.saveVehicle(picked);
        var dest = picked && (ctx.outside || picked.key !== ctx.current.key) ? match.url : null;
        /* 08 故事模式按目标文章是否就是当前页判断（从示例页确认同一台车也要进已发布的文章） */
        if (storyMode) dest = match.url && new URL(match.url, window.location.href).pathname !== window.location.pathname ? match.url : null;
        if (positionSel) {
          // 正式网址模式：去该车该灯位的安装帮助页（/pages/install/…；没有该页时 context.js 退回预览网址）
          dest = ctx.formal && picked ? ctx.urlForHere(picked, { position: positionSel.value }) : withPosition(dest);
          if (isHere(dest)) dest = null;
        }
        if (dest) {
          window.location.href = dest;
          return;
        }
        closePicker();
        return;
      }
      if (match) {
        try {
          window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ year: year, make: make, model: model }));
        } catch (error) {
          /* 忽略：隐私模式或存储被禁用时不影响原型展示 */
        }
        var here = new URLSearchParams(window.location.search).get('view') || '';
        if (match.url && viewOf(match.url) && viewOf(match.url) !== here) {
          window.location.href = match.url;
          return;
        }
        closePicker();
        return;
      }

      /* 原型只有列表里这几台车的数据：不换车、不伪造适配 */
      var names = targets.map(function (t) { return t.year + ' ' + t.make + ' ' + t.model; });
      setMessage('Preview content is available for ' + names.join(' and ') + ' only.');
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-apsp-vcard]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.getAttribute(READY_ATTR) === '1') return;
      root.setAttribute(READY_ATTR, '1');
      init(root);
    });
    /* 10 / 09 固定页：车型名与下拉已换成访客的车（或留空等目录），去掉服务端加的隐藏（sections/auxito-proto-shell.liquid） */
    document.documentElement.classList.remove('apsp-vpending');
  }

  var existing = window.__auxitoProtoShellVehicleCard;
  if (existing && typeof existing.initAll === 'function') {
    existing.initAll();
  } else {
    window.__auxitoProtoShellVehicleCard = { initAll: initAll };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
  }
})();
